import { ref, watch, Ref } from "vue";

export function useDebounce<T>(value: Ref<T>, delay: number = 300) {
  const debouncedValue = ref<T>(value.value);
  const timeoutId = ref<NodeJS.Timeout | null>(null);

  watch(value, () => {
    if (timeoutId.value) {
      clearTimeout(timeoutId.value);
    }

    timeoutId.value = setTimeout(() => {
      debouncedValue.value = value.value;
    }, delay);
  });

  return debouncedValue;
}
